import React from 'react';
import ONCRP_TOOLS_QP_Card from './OncoRiskCard';
import { KeyValue } from './CommonComponents';

const PredictionsEvidenceCard = ({ vepData, oncoKbData }) => {
    if (!vepData) return null;

    return (
        <ONCRP_TOOLS_QP_Card title="Predictions & Evidence" icon="fa-brain" className="ONCRP-TOOLS-QP-span-col-6">
            <div className="ONCRP-TOOLS-QP-subsection">
                <h4>In-Silico Predictions</h4>
                <div className="ONCRP-TOOLS-QP-kv-grid">
                    {vepData.transcript_consequences?.slice(0, 1).map((tc, i) => (
                        <React.Fragment key={i}>
                            <KeyValue label="SIFT">{`${tc.sift_prediction} (${tc.sift_score})`}</KeyValue>
                            <KeyValue label="PolyPhen">{`${tc.polyphen_prediction} (${tc.polyphen_score})`}</KeyValue>
                            <KeyValue label="REVEL">{`${tc.revel_score} (Rank: ${tc.revel_rankscore})`}</KeyValue>
                            {tc.alphamissense && <KeyValue label="AlphaMissense">{`${tc.alphamissense.am_class.replace(/_/g, ' ')} (${tc.alphamissense.am_pathogenicity?.toFixed(4)})`}</KeyValue>}
                            {tc.bayesdel_addaf_score && <KeyValue label="BayesDel (w/ AF)">{`${tc.bayesdel_addaf_pred} (${tc.bayesdel_addaf_score?.toFixed(4)})`}</KeyValue>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="ONCRP-TOOLS-QP-section">
                <h4>OncoKB Key Levels</h4>
                <div className="ONCRP-TOOLS-QP-kv-grid">
                    <KeyValue label="Highest Sensitivity">{oncoKbData?.keyEvidenceLevels?.highestSensitivity}</KeyValue>
                    <KeyValue label="Highest Resistance">{oncoKbData?.keyEvidenceLevels?.highestResistance}</KeyValue>
                    <KeyValue label="FDA Recognition">{oncoKbData?.keyEvidenceLevels?.highestFdaRecognition}</KeyValue>
                </div>
            </div>
        </ONCRP_TOOLS_QP_Card>
    );
};

export default PredictionsEvidenceCard; 